module.exports = __webpack_public_path__ + "img/MEX.7c700edf.png";